<template>
  <success :show-promotes='showPromotes'>
    <thanks :title='title'>
      <template v-if="isDown">
        <template v-if="hasZPSetUp">
          <subtitle :sub-title="$t('billing.success.confirmation.set_up_zp_desc')" />
          <subtitle v-if='bookWithSpecialistLink' :sub-title="$t('billing.pbx.pbx_specialist_new')" />
          <set-up-action :eligibleProductTypeJson='eligibleProductTypeJson'/>
          <book-with-a-specialist />
        </template>
        <view-account v-else />
      </template>
      <template v-else-if="isUp">
        <template v-if="hasZPSetUp">
          <subtitle :sub-title="$t('billing.success.confirmation.set_up_zp_desc')" />
          <subtitle v-if='bookWithSpecialistLink' :sub-title="$t('billing.pbx.pbx_specialist_new')" />
          <set-up-action :eligibleProductTypeJson='eligibleProductTypeJson'/>
          <book-with-a-specialist />
        </template>
        <template v-else>
          <subtitle :sub-title="$t('billing.success.confirmation.user_assign_desc')" />
          <user-management-cta :cta-name="$t('billing.success.confirmation.user_cta')" :is-zp="true" />
        </template>
      </template>
      <template v-else>
        <template v-if="hasZPSetUp">
          <subtitle :sub-title="$t('billing.success.confirmation.set_up_zp_desc')" />
          <subtitle v-if='bookWithSpecialistLink' :sub-title="$t('billing.pbx.pbx_specialist_new')" />
          <set-up-action :eligibleProductTypeJson='eligibleProductTypeJson'/>
          <book-with-a-specialist />
        </template>
        <view-account v-else/>
        <download-action v-if="isBuyNow"/>
      </template>
    </thanks>
  </success>
</template>

<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template';
import DownloadAction from '@/views/succezz/thanks-template/download-action.vue';
import { mapGetters } from 'vuex';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import { includes } from 'lodash';
import { companySetupProductTypeMap } from '@/common/constants';
import { isEmptyVal, safeJSONParse } from '@/utils';
import { PLAN_CHANGE_TYPE } from '@/common/service/validate/downsell';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import SetUpAction from '@/views/succezz/thanks-template/set-up-action.vue';
import common from '@/views/succezz/mixin/common';
import BookWithASpecialist from '@/views/succezz/thanks-template/book-with-a-specialist.vue';

export default {
  mixins: [common],
  components: {
    BookWithASpecialist,
    SetUpAction,
    Subtitle,
    UserManagementCta,
    ViewAccount,
    DownloadAction,
    Success,
    Thanks,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['persistState','successConfig']),
    bookWithSpecialistLink() {
      return this.successConfig.bookWithSpecialistLink;
    },
    showPromotes() {
      return false;
    },
    isBuyNow() {
      return this.$context.is.buyNow;
    },
    eligibleProductTypeJson() {
      return this.successConfig?.eligibleProductTypeJson || '[]';
    },
    setUpList() {
      const eligibleProductType = safeJSONParse(this.eligibleProductTypeJson, []);
      return isEmptyVal(eligibleProductType) ?
        safeJSONParse(this.$config?.('eligibleProductTypeJson') || '[]', [])
        : eligibleProductType;
    },
    hasZPSetUp() {
      return includes(this.setUpList, companySetupProductTypeMap.pbx);
    },
    isDown(){
      return  this.persistState.downgradeState?.status === PLAN_CHANGE_TYPE.DOWN;
    },
    isUp(){
      return  this.persistState.downgradeState?.status === PLAN_CHANGE_TYPE.UP;
    }
  },
};
</script>
